import { Field } from 'components/Field'
import { FormFieldProps } from 'components/FormFields'
import React, { HTMLProps } from 'react'
import styled, { css } from 'styled-components'

export const emailFieldStyles = css``

const EmailFieldView = styled.div`
	${emailFieldStyles}
`

export type EmailFieldProps = Pick<
	HTMLProps<HTMLInputElement>,
	'onChange' | 'title' | 'className'
> &
	FormFieldProps & {}

export const EmailField = ({
	onChange,
	title,
	className,
	name,
	...fieldProps
}: EmailFieldProps) => {
	const props = {
		name,
		type: 'email',
		onChange,
		title,
	}

	return (
		<EmailFieldView className={`email-field${className ? ` ${className}` : ''}`}>
			<Field {...fieldProps} name={name}>
				<input {...props} />
			</Field>
		</EmailFieldView>
	)
}
